import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { DealerViewModel } from "src/domain/client";
import { nonNullish } from "src/guards";
import { ChannelRequestService } from "src/services/channel-request.service";
import { ModelAndDealerService } from "src/services/model-and-dealer.service";

@Component({
  selector: "vw-dealer-information",
  templateUrl: "./dealer-information.component.html",
})
export class DealerInformationComponent implements OnInit, OnDestroy {
  @Input() dealer?: DealerViewModel;

  get googleMapsLinkArgs() {
    return [
      this.dealer?.streetAddress,
      this.dealer?.postalCode,
      this.dealer?.city,
    ].filter(nonNullish);
  }

  options?: google.maps.MapOptions;
  marker?: google.maps.MarkerOptions;

  private channelRequestSubscription?: Subscription;

  constructor(
    private channelRequestService: ChannelRequestService,
    private modelAndDealerService: ModelAndDealerService,
  ) {}

  ngOnInit(): void {
    this.channelRequestSubscription =
      this.channelRequestService.channelRequestUpdated$.subscribe(() => {
        if (this.modelAndDealerService.selectedDealer) {
          this.setOptions(this.modelAndDealerService.selectedDealer);
          this.setMarker(this.modelAndDealerService.selectedDealer);
        }
      });

    if (this.dealer?.longitude != null && this.dealer?.latitude != null) {
      this.setOptions(this.dealer);
      this.setMarker(this.dealer);
    }
  }

  ngOnDestroy(): void {
    this.channelRequestSubscription?.unsubscribe();
  }

  //////////

  private setOptions(dealer: DealerViewModel): void {
    this.options = {
      center:
        dealer.latitude != null && dealer.longitude != null
          ? {
              lat: dealer.latitude,
              lng: dealer.longitude,
            }
          : null,
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
    };
  }

  private setMarker(dealer: DealerViewModel): void {
    if (dealer.latitude == null || dealer.longitude == null) return;
    this.marker = {
      position: {
        lat: dealer.latitude,
        lng: dealer.longitude,
      },
      icon: {
        url: "/assets/img/marker.png",
        scaledSize: new google.maps.Size(25, 35),
      },
    };
  }
}
